/**
 * SectionErrorTrackers.js
 * Individual error tracker instances for each section
 * Each section has its own isolated error tracking and listener system
 */

import errorTrackerV2 from "./ErrorTrackerV2";

/**
 * Section 1 - Applicant Details
 */
export const section1Tracker = {
  sectionKey: "section1",
  label: "Applicant Details",

  addListener(callback) {
    return errorTrackerV2.addSectionListener(this.sectionKey, callback);
  },

  getState() {
    return errorTrackerV2.getSectionState(this.sectionKey);
  },

  setErrors(errors) {
    errorTrackerV2.setSectionErrors(this.sectionKey, errors);
  },

  mergeErrors(errors) {
    errorTrackerV2.mergeErrors(this.sectionKey, errors);
  },

  hasErrors() {
    return errorTrackerV2.hasErrors(this.sectionKey);
  },

  getErrors() {
    return errorTrackerV2.getErrors(this.sectionKey);
  },
};

/**
 * Section 2 - Professional Qualifications
 */
export const section2Tracker = {
  sectionKey: "section2",
  label: "Professional Qualifications",

  addListener(callback) {
    return errorTrackerV2.addSectionListener(this.sectionKey, callback);
  },

  getState() {
    return errorTrackerV2.getSectionState(this.sectionKey);
  },

  setErrors(errors) {
    errorTrackerV2.setSectionErrors(this.sectionKey, errors);
  },

  mergeErrors(errors) {
    errorTrackerV2.mergeErrors(this.sectionKey, errors);
  },

  hasErrors() {
    return errorTrackerV2.hasErrors(this.sectionKey);
  },

  getErrors() {
    return errorTrackerV2.getErrors(this.sectionKey);
  },
};

/**
 * Section 3 - Activity
 */
export const section3Tracker = {
  sectionKey: "section3",
  label: "Activity",

  addListener(callback) {
    return errorTrackerV2.addSectionListener(this.sectionKey, callback);
  },

  getState() {
    return errorTrackerV2.getSectionState(this.sectionKey);
  },

  setErrors(errors) {
    errorTrackerV2.setSectionErrors(this.sectionKey, errors);
  },

  mergeErrors(errors) {
    errorTrackerV2.mergeErrors(this.sectionKey, errors);
  },

  hasErrors() {
    return errorTrackerV2.hasErrors(this.sectionKey);
  },

  getErrors() {
    return errorTrackerV2.getErrors(this.sectionKey);
  },
};

/**
 * Section 4 - Company Directorship Details
 */
export const section4Tracker = {
  sectionKey: "section4",
  label: "Company Directorship Details",

  addListener(callback) {
    return errorTrackerV2.addSectionListener(this.sectionKey, callback);
  },

  getState() {
    return errorTrackerV2.getSectionState(this.sectionKey);
  },

  setErrors(errors) {
    errorTrackerV2.setSectionErrors(this.sectionKey, errors);
  },

  mergeErrors(errors) {
    errorTrackerV2.mergeErrors(this.sectionKey, errors);
  },

  hasErrors() {
    return errorTrackerV2.hasErrors(this.sectionKey);
  },

  getErrors() {
    return errorTrackerV2.getErrors(this.sectionKey);
  },
};

/**
 * Section 5 - Accountant Details
 */
export const section5Tracker = {
  sectionKey: "section5",
  label: "Accountant Details",

  addListener(callback) {
    return errorTrackerV2.addSectionListener(this.sectionKey, callback);
  },

  getState() {
    return errorTrackerV2.getSectionState(this.sectionKey);
  },

  setErrors(errors) {
    errorTrackerV2.setSectionErrors(this.sectionKey, errors);
  },

  mergeErrors(errors) {
    errorTrackerV2.mergeErrors(this.sectionKey, errors);
  },

  hasErrors() {
    return errorTrackerV2.hasErrors(this.sectionKey);
  },

  getErrors() {
    return errorTrackerV2.getErrors(this.sectionKey);
  },
};

/**
 * Section 6 - Business Conduct
 */
export const section6Tracker = {
  sectionKey: "section6",
  label: "Business Conduct",

  addListener(callback) {
    return errorTrackerV2.addSectionListener(this.sectionKey, callback);
  },

  getState() {
    return errorTrackerV2.getSectionState(this.sectionKey);
  },

  setErrors(errors) {
    errorTrackerV2.setSectionErrors(this.sectionKey, errors);
  },

  mergeErrors(errors) {
    errorTrackerV2.mergeErrors(this.sectionKey, errors);
  },

  hasErrors() {
    return errorTrackerV2.hasErrors(this.sectionKey);
  },

  getErrors() {
    return errorTrackerV2.getErrors(this.sectionKey);
  },
};

/**
 * Section 7 - Fitness and Propriety
 */
export const section7Tracker = {
  sectionKey: "section7",
  label: "Fitness and Propriety",

  addListener(callback) {
    return errorTrackerV2.addSectionListener(this.sectionKey, callback);
  },

  getState() {
    return errorTrackerV2.getSectionState(this.sectionKey);
  },

  setErrors(errors) {
    errorTrackerV2.setSectionErrors(this.sectionKey, errors);
  },

  mergeErrors(errors) {
    errorTrackerV2.mergeErrors(this.sectionKey, errors);
  },

  hasErrors() {
    return errorTrackerV2.hasErrors(this.sectionKey);
  },

  getErrors() {
    return errorTrackerV2.getErrors(this.sectionKey);
  },
};

/**
 * Section 8 - Overall Financial Position
 */
export const section8Tracker = {
  sectionKey: "section8",
  label: "Overall Financial Position",

  addListener(callback) {
    return errorTrackerV2.addSectionListener(this.sectionKey, callback);
  },

  getState() {
    return errorTrackerV2.getSectionState(this.sectionKey);
  },

  setErrors(errors) {
    errorTrackerV2.setSectionErrors(this.sectionKey, errors);
  },

  mergeErrors(errors) {
    errorTrackerV2.mergeErrors(this.sectionKey, errors);
  },

  hasErrors() {
    return errorTrackerV2.hasErrors(this.sectionKey);
  },

  getErrors() {
    return errorTrackerV2.getErrors(this.sectionKey);
  },
};

/**
 * Section 9 - Additional Information
 */
export const section9Tracker = {
  sectionKey: "section9",
  label: "Additional Information",

  addListener(callback) {
    return errorTrackerV2.addSectionListener(this.sectionKey, callback);
  },

  getState() {
    return errorTrackerV2.getSectionState(this.sectionKey);
  },

  setErrors(errors) {
    errorTrackerV2.setSectionErrors(this.sectionKey, errors);
  },

  mergeErrors(errors) {
    errorTrackerV2.mergeErrors(this.sectionKey, errors);
  },

  hasErrors() {
    return errorTrackerV2.hasErrors(this.sectionKey);
  },

  getErrors() {
    return errorTrackerV2.getErrors(this.sectionKey);
  },
};

/**
 * Section 10 - Unemployment Details
 */
export const section10Tracker = {
  sectionKey: "section10",
  label: "Unemployment Details",

  addListener(callback) {
    return errorTrackerV2.addSectionListener(this.sectionKey, callback);
  },

  getState() {
    return errorTrackerV2.getSectionState(this.sectionKey);
  },

  setErrors(errors) {
    errorTrackerV2.setSectionErrors(this.sectionKey, errors);
  },

  mergeErrors(errors) {
    errorTrackerV2.mergeErrors(this.sectionKey, errors);
  },

  hasErrors() {
    return errorTrackerV2.hasErrors(this.sectionKey);
  },

  getErrors() {
    return errorTrackerV2.getErrors(this.sectionKey);
  },
};

/**
 * Section 11 - Declaration
 */
export const section11Tracker = {
  sectionKey: "section11",
  label: "Declaration",

  addListener(callback) {
    return errorTrackerV2.addSectionListener(this.sectionKey, callback);
  },

  getState() {
    return errorTrackerV2.getSectionState(this.sectionKey);
  },

  setErrors(errors) {
    errorTrackerV2.setSectionErrors(this.sectionKey, errors);
  },

  mergeErrors(errors) {
    errorTrackerV2.mergeErrors(this.sectionKey, errors);
  },

  hasErrors() {
    return errorTrackerV2.hasErrors(this.sectionKey);
  },

  getErrors() {
    return errorTrackerV2.getErrors(this.sectionKey);
  },
};

/**
 * All section trackers as an array for iteration
 */
export const allSectionTrackers = [
  section1Tracker,
  section2Tracker,
  section3Tracker,
  section4Tracker,
  section5Tracker,
  section6Tracker,
  section7Tracker,
  section8Tracker,
  section9Tracker,
  section10Tracker,
  section11Tracker,
];

/**
 * Get a tracker by section key
 */
export const getSectionTracker = (sectionKey) => {
  return allSectionTrackers.find(
    (tracker) => tracker.sectionKey === sectionKey,
  );
};
